import React from 'react';
import { ReactComponent as Icon } from './star-icon.svg';

const StarIcon = () => (
	<Icon/>
);

export default StarIcon;
